import {useEffect, useMemo} from 'react';

import {recordRumAction} from '../../../util/datadog/datadogRum';
import {
  useStatsigGateBackendLineConstruction,
  useStatsigGateBackendLineConstructionGrouped,
  useStatsigGateBackendLineConstructionReports,
  useStatsigGateBackendLineConstructionSmoothing,
} from '../../../util/rampFeatureFlags/linePlotFeatureFlags';

export type BackendLineConstructionFlags = {
  canUseBackendLineConstruction: boolean;
  canUseBackendLineConstructionGrouped: boolean;
  canUseBackendLineConstructionInReports: boolean;
  canUseBackendLineConstructionSmoothing: boolean;
};

export const useBackendLineConstruction = (): BackendLineConstructionFlags => {
  const canUseBackendLineConstruction = useStatsigGateBackendLineConstruction();
  const canUseBackendLineConstructionGrouped =
    useStatsigGateBackendLineConstructionGrouped();
  const canUseBackendLineConstructionInReports =
    useStatsigGateBackendLineConstructionReports();
  const canUseBackendLineConstructionSmoothing =
    useStatsigGateBackendLineConstructionSmoothing();

  // track
  useEffect(() => {
    recordRumAction('Backend Line Construction: Panel Load', {
      useBackendLineConstruction: canUseBackendLineConstruction,
      useBackendLineConstructionGrouped: canUseBackendLineConstructionGrouped,
      useBackendLineConstructionInReports:
        canUseBackendLineConstructionInReports,
      useBackendLineConstructionSmoothing:
        canUseBackendLineConstructionSmoothing,
    });
  }, [
    canUseBackendLineConstruction,
    canUseBackendLineConstructionGrouped,
    canUseBackendLineConstructionInReports,
    canUseBackendLineConstructionSmoothing,
  ]);

  return useMemo(
    () => ({
      canUseBackendLineConstruction,
      canUseBackendLineConstructionGrouped,
      canUseBackendLineConstructionInReports,
      canUseBackendLineConstructionSmoothing,
    }),
    [
      canUseBackendLineConstruction,
      canUseBackendLineConstructionGrouped,
      canUseBackendLineConstructionInReports,
      canUseBackendLineConstructionSmoothing,
    ]
  );
};
